<template>
    <section>
        <b-container fluid class="bg-users">
            <b-list-group>
                <b-list-group-item href="https://docs.google.com/document/d/1FJc-iFnmaQ0gXfxmjs2Uvv525FPKUMUkj7vXhSNaKts/edit">Logging time</b-list-group-item>
                <b-list-group-item href="https://hangouts.google.com/hangouts/_/event/giraffe_software" >Hangouts</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/spreadsheets/d/1WGubN9C2D6OfCl_iMYD_5d6wH2S8ZPuydDMYjliQQ74/edit#gid=1030526819">Client form</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/document/d/1pB7cyvZ2CkzE4BSD3LHDl_yNj3iElRUYpaVHDEKrsPU/edit">Initialization of the project</b-list-group-item>
                <b-list-group-item href="https://drive.google.com/drive/folders/1-SnGCIaZkvVvq_dL-_VDsZGPQ701ypP5">QA team</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/document/d/1EzMa7_BXT98dHdDqTt1osDywGLIHV4osiLM9SypG5oo/edit">Description of projects</b-list-group-item>
            </b-list-group>
        </b-container>
    </section>
</template>
<script>
export default {
  name: 'users-info-pm',
  data () {
    return {

    }
  },
  methods: {
  },
  mounted () {

  }
}
</script>

<style scoped>
    .bg-users {
        padding: 20px;
    }
</style>
